import {OrderedSet} from 'immutable';

export const ADMIN = 'administrator';
export const USER = 'User';
export const EDUCATION_ADMIN = 'education_administrator';
export const ALL = new OrderedSet([ADMIN, USER, EDUCATION_ADMIN]);



// WEBPACK FOOTER //
// ./app/features/authentication/constants/roles.js